import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

export const useOnePageCheckout = () => useAppSelector(state => state.pages.onePageCheckout);

export const useOnePageCheckoutConfirmation = () => useAppSelector(state => state.pages.onePageCheckoutConfirmation);
